import Input from './Input';
import { ChangeEvent, FormEvent, useState } from 'react';
import { AxiosError } from 'axios';
import { Navigate } from 'react-router-dom';
import useAdminUser from '../contexts/AdminUserContext';
import useLoading from '../contexts/LoadingContext';
import { useTranslation } from 'react-i18next';

export default function Login() {
  const [t] = useTranslation(['common']);
  const adminUser = useAdminUser();
  const { setIsLoading } = useLoading();
  const [isSignIn, setIsSignIn] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errMessage, setErrMessage] = useState('');
  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const onPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const onSignInClick = (event: FormEvent) => {
    event.preventDefault();

    setIsLoading(true);
    adminUser
      .login(email, password)
      .then(() => {
        setIsSignIn(true);
      })
      .catch((error: AxiosError) => {
        setIsSignIn(false);
        const res = error.response;
        if (res && res.status === 401) {
          setErrMessage(
            t('signin_fail', '登入失敗，請確認使用者名稱及密碼是否正確')
          );
          return;
        }
        setErrMessage(t('try_later', '請稍候再試'));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isSignIn) {
    return <Navigate to="/admin" />;
  }

  return (
    <div className="flex h-admin w-full justify-center items-center">
      <div className="w-[400px] shadow-regular rounded-xl bg-white">
        <form
          className="flex flex-col h-full w-full items-center pt-5 px-6"
          onSubmit={onSignInClick}
        >
          <span className="text-group-primary text-xl font-medium">
            {t('signin', '登入')}
          </span>
          <span className="mt-5 mb-4 border-t w-full border-[#d9d9d9]"></span>
          <div className="flex flex-col gap-4 w-full">
            <Input
              title={t('username', '使用者名稱')}
              placeholder={t('username_placeholder', '請輸入使用者名稱')}
              onChange={onEmailChange}
            />
            <Input
              title={t('passwd', '密碼')}
              placeholder={t('passwd_placeholder', '請輸入密碼')}
              type="password"
              onChange={onPasswordChange}
            />
          </div>
          <span className="my-2 text-red-600 font-medium text-sm">
            {errMessage}
          </span>
          <button className="bg-group-primary text-white p-3 w-28 rounded text-center disabled:opacity-30 disabled:cursor-not-allowed mb-6">
            {t('signin', '登入')}
          </button>
        </form>
      </div>
    </div>
  );
}
